<template>
  <div class="secret-elems">
    <ArticleViews
      class="secret-elems__elem"
      :article="article"
    />
    <ArticleEdit
      class="secret-elems__elem"
      :article="article"
    />
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import ArticleEdit from '~/components/ArticleEdit.vue';
  import ArticleViews from '~/components/ArticleViews.vue';
  import type { IFullArticle, TArticle } from '~/types/common';

  export default defineNuxtComponent({
    name: 'SecretElems',
    components: {
      ArticleEdit,
      ArticleViews,
    },

    props: {
      article: {
        type: Object as PropType<TArticle | IFullArticle>,
        required: true,
      },
    },
  });
</script>

<style lang="scss">
  .secret-elems {
    display: flex;

    &__elem {
      &:not(:last-child) {
        margin-right: 8px;
      }
    }
  }
</style>
